class Gallery {
    constructor(gallery) {
        
        this.galleryEl = gallery.querySelector(`[data-gallery-el]`);
        this.countInfo = gallery.querySelector(`[data-counter]`);

        this.galleryButtons = gallery.querySelector('.gallery__buttons');
        
        this.activePlugins = [lgFullscreen];
        if (!gallery.hasAttribute('data-remove-thumbs')) {
            this.activePlugins.push(lgThumbnail);
        }

        if(this.galleryEl.children.length > 1){
         this.buildGallery();   
        }else{
            this.galleryButtons && this.galleryButtons.remove();
            this.countInfo && this.countInfo.remove();
        }
    }
    
    buildGallery(galleryEl) {{
        const lg = lightGallery(this.galleryEl, {
            speed: 500,
            container: this.galleryEl,
            plugins: this.activePlugins,
            licenseKey: "4628D369-F2EC4BF8-98F3F83B-F7312AC5",
            closable: false,
            hash: false,
            showCloseIcon: false,
            controls: false,
            download: false,
            appendSubHtmlTo: '.lg-item',
            thumbHeight: '80px',
            thumbWidth: 120,
            thumbMargin: 20,
            fullscreen: true,
            showMaximizeIcon: true,
            exThumbImage: 'data-external-thumb-image'
        });

        lg.openGallery(0);

        const itemCount = lg.galleryItems.length;

        const dialogue = lg.el.querySelector(".lg-container");

        dialogue.setAttribute("aria-labelledby","lg-inner-1");

        // This event fires once the gallery is fully opened and visible
        this.galleryEl.addEventListener('lgAfterOpen', (event) => {
            const maximizeButton = this.galleryEl.querySelector('.lg-maximize');
            if (maximizeButton) {
                maximizeButton.classList.remove('lg-icon');
                maximizeButton.classList.add('button', 'button--3');
            }
        });

        this.galleryEl.addEventListener('lgBeforeSlide', (event) => {
            // Correct way: use event.detail.index
            const currentIndex = event.detail.index;
            if (this.countInfo) {
                this.countInfo.innerHTML = `${(currentIndex + 1)} of ${itemCount}`;
            }
        });

        this.galleryEl.querySelectorAll(".lg-thumb-item").forEach(thumb => {
            thumb.setAttribute("tabindex", "0");
            thumb.addEventListener("keypress", e=>{
                if(e.code === "Enter"){
                    thumb.click();
                }
            })
        });

        if (this.galleryButtons) {
            this.galleryButtons.children[0].addEventListener('click', () => {
                lg.goToPrevSlide();
            });

            this.galleryButtons.children[1].addEventListener('click', () => {
                lg.goToNextSlide();
            });
        }
    }}
}

ControlBinders.register(`[data-gallery]`, el => new Gallery(el));
